import { useState, useRef } from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { CustomEmojiCategory, defaultCustomEmojis } from "@/lib/custom-emojis";

interface EmojiPickerProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  customEmojis?: CustomEmojiCategory[];
}

interface EmojiSelection {
  native: string;
  id: string;
  name: string;
  unified: string;
  imageUrl?: string;
  src?: string;
}

export function EmojiPicker({
  value,
  onChange,
  placeholder = "Select an icon",
  customEmojis = defaultCustomEmojis,
}: EmojiPickerProps) {
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleEmojiSelect = (emoji: EmojiSelection) => {
    // For custom emojis, we use src if available
    if (emoji.src) {
      onChange(emoji.src);
    } else {
      onChange(emoji.native);
    }
    setOpen(false);
  };

  return (
    <div className="flex gap-2">
      <Input
        ref={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1"
      />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" className="px-3">
            {value ? (
              value.startsWith("http") ? (
                <img src={value} alt="Custom emoji" className="w-6 h-6" />
              ) : (
                value
              )
            ) : (
              "😊"
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="p-0 border-0" align="end" sideOffset={5}>
          <div style={{ width: "350px" }}>
            <Picker
              data={data}
              onEmojiSelect={handleEmojiSelect}
              theme="auto"
              set="native"
              previewPosition="none"
              skinTonePosition="none"
              custom={customEmojis}
            />
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
